import { render } from "./DetalleModulos.vue?vue&type=template&id=2491f35a&scoped=true"
import script from "./DetalleModulos.vue?vue&type=script&lang=js"
export * from "./DetalleModulos.vue?vue&type=script&lang=js"

import "./DetalleModulos.vue?vue&type=style&index=0&id=2491f35a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2491f35a"]])

export default __exports__